module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boleta"
  }, [_c('div', {
    staticClass: "datos"
  }, [_vm._m(0), _c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "up"
  }, [_c('div', {
    staticClass: "big"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.boleta.nombreMes) + " " + _vm._s(_vm.boleta.periodo))]), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.boleta.descripcionTipo))])]), _c('div', {
    staticClass: "small"
  }, [_c('span', [_vm._v("Generado: " + _vm._s(_vm.boleta.fechaGenerado))])])]), _c('div', {
    staticClass: "down"
  }, [_c('div', {
    staticClass: "button",
    class: {
      'is-primary': !_vm.boleta.visto
    },
    on: {
      "click": _vm.ver
    }
  }, [(_vm.boleta.visto) ? _c('div', {
    staticClass: "button-fecha"
  }, [_c('p', [_vm._v("Ver")]), _c('div', {
    staticClass: "fecha"
  }, [_vm._v("Visto en " + _vm._s(_vm.boleta.fechaVisto))])]) : _c('div', [_c('span', [_vm._v("Ver")])])]), (!_vm.boleta.visto) ? _c('p', {
    staticClass: "small has-text-centered"
  }, [_vm._v("Al ver su boleta, acepta la recepción de la misma")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fd62446","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Boletas_Item_Lista.vue
// module id = 851
// module chunks = 0